import scales from "../foundations/scales";
const radii = {
    '2xs': scales[0.125],
    xs: scales[0.25],
    s: scales[0.5],
    m: scales[0.75],
    l: scales[1],
    rounded: scales[16],
    /**
	 * Fix to support chakra opiniated theming
	 * @deprecated use `rounded` instead
	 */ full: scales[16]
};
export default radii;

//# sourceMappingURL=radius.js.map